export default [
    {
        path: '/containers',
        name: 'Containers',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: ['SALES'],
        },
        components: {
            default: () => import('@views/containers/ContainerIndex.vue'),
        },
    },
    {
        path: '/containers/create',
        name: 'ContainerCreate',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            title: 'Create container',
            denyRoles: ['SALES'],
        },
        components: {
            default: () => import('@views/containers/ContainerCreate.vue'),
        },
    },
    {
        path: '/containers/:id/edit',
        name: 'ContainerEdit',
        props: {
            default: (route) => ({ id: route.params.id }),
        },
        meta: {
            requiresAuth: true,
            allowRoles: null,
            title: 'Edit container',
            denyRoles: ['SALES'],
        },
        components: {
            default: () => import('@views/containers/ContainerEdit.vue'),
        },
    },
];
